module.exports = __webpack_public_path__ + "img/d.7eb75e08.png";